import { sendAchDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: sendAchDepositSlice, asyncAction: sendAchDepositAction } = createAsyncSlice(
  'sendAchDepositSlice',
  sendAchDepositAsync
);
